<template>
  <div>
    <b-nav-item v-if="route.path" :to="buildPath(route.path)">
      <font-awesome-icon
        v-if="route.meta.sidebar.icon"
        :icon="route.meta.sidebar.icon"
        style="width: 18px"
        class="mr-2"
      />
      <span v-html="route.meta.navbar.displayName" />
    </b-nav-item>

    <div
      v-else
      :class="`d-flex ml-3 mb-2 ${route.click ? 'blue link' : ''}`"
      @click="route.click ? route.click() : null"
    >
      <font-awesome-icon
        v-if="route.meta.sidebar.icon"
        :icon="route.meta.sidebar.icon"
        style="width: 18px"
        class="mr-2 mt-1 blue"
      />
      <div v-html="route.meta.navbar.displayName" />
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Vue, Component } from 'vue-property-decorator'
import { routeBuild } from '@/utils/urls'

@Component
export default class RouteCard extends Vue {
  @Prop(Object) readonly route!: any

  private buildPath(url: string) {
    const options = this.route.meta.sidebar?.routeBuildOptions
    return options ? routeBuild(url, options) : url
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
.blue {
  color: map-get($french-palette, 'blue-3');
}
.link:hover {
  cursor: pointer;
}
</style>
